module.exports = __webpack_public_path__ + "static/img/poster.38fab0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/poster.png
// module id = 3Svo
// module chunks = 74